import React from 'react';
import styles from './Separator.module.css';

const Separator = () => <div className={styles.separator} />;

export default Separator;
